export const VALUE = "value";
export const SELECTION = "selection";
export const ACTIONS = "actions";
